import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NavigationRailActions } from '@next/core-lib/components';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { NavigationActions, ParentNavigationItem } from '@next/core-lib/navigation';
import { SelectedLocation, UserSelectors } from '@next/core-lib/user';
import {
  AgrWrapperSiteSidenavModule,
  WrapperSiteSidenavActions,
} from '@next/core-lib/wrapper-site-sidenav';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Environment } from '../environment';

import { SiteState } from './shared/models/models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, AgrWrapperSiteSidenavModule],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);
  env = inject<Environment>(EnvironmentInjector);

  private readonly location$: Observable<SelectedLocation> = this.store.pipe(
    select(UserSelectors.selectLocation),
  );
  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.store.dispatch(
      NavigationActions.setNavigationItems({
        navigationItems: this.getNavigationItems(),
      }),
    );
    this.store.dispatch(WrapperSiteSidenavActions.collapseSidenav());
    this.store.dispatch(NavigationRailActions.hideNavigationRail());

    if (this.env.POWER_BI_LINK_ENABLED) {
      this.location$
        .pipe(
          filter((location) => !!location),
          takeUntil(this.destroy$),
        )
        .subscribe((location) => {
          const queryParam = encodeURIComponent(`shakerbox/bk_customer eq '${location.id}'`);
          const absoluteUrl = `${this.env.POWER_BI_URL}&filter=${queryParam}`;
          const navigationItems = [
            ...this.getNavigationItems(),
            {
              label: 'app.power-bi',
              absoluteUrl,
              icon: 'analytics',
              newWindow: true,
              hideNewWindowIcon: true,
            },
          ];

          this.store.dispatch(
            NavigationActions.setNavigationItems({
              navigationItems,
            }),
          );
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getNavigationItems(): ParentNavigationItem[] {
    return [
      {
        relativeUrl: '/',
        label: 'app.measurements-module',
        icon: 'insights',
      },
    ];
  }
}
